import { lazyLoad } from 'utils/loadable';

export const BookitLabDashboadPage = lazyLoad(
  () => import('./index'),
  module => module.BookitLabDashboadPage,
);
